"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogManager = void 0;
/* eslint-disable no-console */
const client_core_1 = require("@statsig/client-core");
const AutoCaptureEvent_1 = require("./AutoCaptureEvent");
const commonUtils_1 = require("./utils/commonUtils");
const metadataUtils_1 = require("./utils/metadataUtils");
const ConsoleLogPriority = {
    trace: 10,
    debug: 20,
    log: 30, // log & info are the same priority
    info: 30,
    warn: 40,
    error: 50,
};
class ConsoleLogManager {
    constructor(_enqueueFn, _options) {
        var _a;
        this._enqueueFn = _enqueueFn;
        this._options = _options;
        this._restoreFns = [];
        this._isTracking = false;
        this._logLevel = 'info';
        this.__source = 'js-auto-capture';
        this._logLevel = (_a = this._options.logLevel) !== null && _a !== void 0 ? _a : 'info';
    }
    startTracking() {
        if (this._isTracking || !this._options.enabled)
            return;
        const win = (0, client_core_1._getWindowSafe)();
        if (!win)
            return;
        this._isTracking = true;
        this._patchConsole();
    }
    stopTracking() {
        if (!this._isTracking)
            return;
        this._restoreFns.forEach((restore) => restore());
        this._restoreFns = [];
        this._isTracking = false;
    }
    _patchConsole() {
        Object.entries(ConsoleLogPriority).forEach(([level, priority]) => {
            if (priority < ConsoleLogPriority[this._logLevel])
                return;
            if (!console[level])
                return;
            const original = console[level].bind(console);
            let inStack = false;
            const restore = (0, commonUtils_1.patch)(console, level, (originalFn) => {
                return (...args) => {
                    originalFn(...args);
                    if (inStack)
                        return;
                    inStack = true;
                    try {
                        const payload = args.map((a) => this._safeStringify(a));
                        const trace = this._getStackTrace();
                        this._enqueueConsoleLog(level, payload, trace);
                    }
                    catch (err) {
                        original('console observer error:', err, ...args);
                    }
                    finally {
                        inStack = false;
                    }
                };
            });
            this._restoreFns.push(restore);
        });
    }
    _enqueueConsoleLog(level, payload, trace) {
        if (!this._shouldLog())
            return;
        const metadata = Object.assign({ status: level === 'log' ? 'info' : level, log_level: level, payload,
            trace, timestamp: Date.now(), source: this.__source }, (0, metadataUtils_1._gatherAllMetadata)((0, commonUtils_1._getSafeUrl)()));
        this._enqueueFn(AutoCaptureEvent_1.AutoCaptureEventName.CONSOLE_LOG, payload.join(' '), metadata);
    }
    _shouldLog() {
        if (!this._options.sampleRate ||
            typeof this._options.sampleRate !== 'number' ||
            this._options.sampleRate <= 0 ||
            this._options.sampleRate >= 1) {
            return true;
        }
        return Math.random() < this._options.sampleRate;
    }
    _safeStringify(val) {
        try {
            if (typeof val === 'string')
                return val;
            if (typeof val === 'object' && val !== null)
                return JSON.stringify(val);
            return String(val);
        }
        catch (_a) {
            return '[Unserializable]';
        }
    }
    _getStackTrace() {
        var _a, _b;
        try {
            return (_b = (_a = new Error().stack) === null || _a === void 0 ? void 0 : _a.split('\n').slice(2)) !== null && _b !== void 0 ? _b : [];
        }
        catch (_c) {
            return [];
        }
    }
}
exports.ConsoleLogManager = ConsoleLogManager;
